module.exports = __webpack_public_path__ + "img/sferro01.eada74d2.png";